<template>
  <div :class="{ show: isShow }" class="header-search">
    <svg-icon
      id="guide-search"
      class-name="search-icon"
      icon="search"
      @click.stop="onShowClick"
    />
    <el-select
      ref="headerSearchSelectRef"
      class="header-search-select"
      v-model="search"
      filterable
      default-first-option
      remote
      placeholder="Search"
      :remote-method="querySearch"
      @change="onSelectChange"
    >
      <el-option
        v-for="option in searchOptions"
        :key="option.item.path"
        :label="option.item.title.join(' > ')"
        :value="option.item"
      ></el-option>
    </el-select>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { filterRouters } from '@/utils/route'
import { generateRoutes } from './FuseData'
import { watchSwitchLang } from '@/utils/i18n'
import Fuse from 'fuse.js'
const router = useRouter()
const isShow = ref(false)
const onShowClick = () => {
  isShow.value = !isShow.value
}
const headerSearchSelectRef = ref(null)
const searchOptions = ref([])
const search = ref('')
const searchPool = computed(() => {
  const filterRouter = filterRouters(router.getRoutes())
  return generateRoutes(filterRouter)
})

// 初始化fuse
let fuse
const initFuse = (searchPool) => {
  fuse = new Fuse(searchPool, {
    shouldSort: true, // 按优先级排序
    // threshold: 0.4, 匹配度
    // location: 0, 匹配位置
    // distance: 100, 匹配字符长度
    // maxPatternLength: 32,  匹配字符长度
    minMatchCharLength: 1, // 匹配长度小于1的，不显示
    keys: [
      {
        name: 'title',
        weight: 0.7
      },
      {
        name: 'path',
        weight: 0.3
      }
    ]
  })
}
initFuse(searchPool.value)

watchSwitchLang(() => {
  searchPool.value = computed(() => {
    const filterRouter = filterRouters(router.getRoutes())
    return generateRoutes(filterRouter)
  })
  // 切换语言后的数据重新交给initFuse初始化
  initFuse(searchPool.value)
})
const querySearch = (query) => {
  if (query !== '') {
    searchOptions.value = fuse.search(query)
  } else {
    searchOptions.value = []
  }
}
const onSelectChange = (item) => {
  router.push(item.path)
}
// 点击body可以关掉显示搜索框
const onClose = () => {
  isShow.value = false
  headerSearchSelectRef.value.blur() // 失焦
  searchOptions.value = []
}
watch(isShow, (val) => {
  if (val) {
    document.body.addEventListener('click', onClose)
  } else {
    document.body.removeEventListener('click', onClose)
  }
})
</script>

<style lang="scss" scoped>
.header-search {
  font-size: 0 !important;
  .search-icon {
    cursor: pointer;
    font-size: 18px;
    vertical-align: middle;
  }
  .header-search-select {
    font-size: 18px;
    transition: width 0.2s;
    width: 0;
    overflow: hidden;
    background: transparent;
    border-radius: 0;
    display: inline-block;
    vertical-align: middle;

    ::v-deep .el-input__inner {
      border-radius: 0;
      border: 0;
      padding-left: 0;
      padding-right: 0;
      box-shadow: none !important;
      border-bottom: 1px solid #d9d9d9;
      vertical-align: middle;
    }
  }
  &.show {
    .header-search-select {
      width: 210px;
      margin-left: 10px;
    }
  }
}
</style>
